import { FormEvent, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { login } from '../api/auth.api';
import { ApiRequestError } from '../api/api-client';
import { authStorage } from '../auth/auth-storage';
import { Button } from '../components/atoms/Button';
import { Input } from '../components/atoms/Input';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { setSession } from '../store/authSlice';

export function LoginPage() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isAuthenticated) return <Navigate to="/" replace />;

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      const session = await login({ email, password });
      authStorage.save(session);
      dispatch(setSession(session));
      const from = (location.state as { from?: string } | null)?.from ?? '/';
      navigate(from, { replace: true });
    } catch (requestError) {
      setError(requestError instanceof ApiRequestError ? requestError.message : 'Unable to sign in. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-card">
        <p className="eyebrow">Inventory ERP</p>
        <h1>Sign in</h1>
        <p className="muted">Use your Inventory ERP account to continue.</p>
        <form onSubmit={handleSubmit}>
          <label className="form-field">Email<Input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="admin@example.com" autoComplete="email" required /></label>
          <label className="form-field">Password<Input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="••••••••" autoComplete="current-password" minLength={8} required /></label>
          {error && <p className="feedback feedback--error" role="alert">{error}</p>}
          <Button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Signing in…' : 'Sign in'}</Button>
        </form>
      </section>
    </main>
  );
}
